import { Fragment } from 'react';
import styles from './DownChevron.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { XMLNS } from '@shopify/polaris-viz-core';

function DownChevron({
  accessibilityLabel,
  fill
}) {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("span", {
      className: styles.VisuallyHidden,
      children: accessibilityLabel
    }), /*#__PURE__*/jsx("svg", {
      xmlns: XMLNS,
      "aria-hidden": "true",
      style: {
        fill
      },
      width: "9",
      height: "6",
      viewBox: "0 0 9 6",
      children: /*#__PURE__*/jsx("path", {
        d: "M7.9856 -1.82341e-07L1.0144 -7.91783e-07C0.169527 -8.65644e-07 -0.303739 0.904212 0.21824 1.52112L3.70384 5.64066C4.10923 6.11978 4.89077 6.11978 5.29616 5.64066L8.78176 1.52113C9.30374 0.904213 8.83048 -1.0848e-07 7.9856 -1.82341e-07Z",
        fill: "#F24F62"
      })
    })]
  });
}

export { DownChevron };
